"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _times = _interopRequireDefault(require("lodash/times"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _userAvatar = _interopRequireDefault(require("./user-avatar"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  overflow: hidden;\n  color: ", ";\n  margin: 0 0 0 16px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 13px;\n  line-height: 15px;\n  margin: 0;\n  display: block;\n  color: ", ";\n  width: 140px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  font-size: 15px;\n  line-height: 16px;\n  margin: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  justify-content: left;\n  align-items: center;\n  width: 100%;\n  padding: 16px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Userbox = _styledComponents["default"].div(_templateObject());

var Name = _styledComponents["default"].h2(_templateObject2());

var Email = _styledComponents["default"].span(_templateObject3(), function (props) {
  return props.theme.palette.lightGray.alt;
});

var InfoWrapper = _styledComponents["default"].div(_templateObject4(), function (props) {
  return props.theme.palette.white.main;
});

var UserBox = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(UserBox, _Component);

  var _super = _createSuper(UserBox);

  function UserBox() {
    var _this;

    (0, _classCallCheck2["default"])(this, UserBox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.getInitials = function (name) {
      var letter = name.charAt(0).toUpperCase();
      return letter;
    };

    _this.colorLuminance = function (hex, lum) {
      // validate hex string
      hex = String(hex).replace(/[^0-9a-f]/gi, '');

      if (hex.length < 6) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }

      lum = lum || 0; // convert to decimal and change luminosity

      var rgb = '#'; // no for loop

      (0, _times["default"])(3, function (i) {
        var c = parseInt(hex.substr(i * 2, 2), 16);
        c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
        rgb += ('00' + c).substr(c.length);
      });
      return rgb;
    };

    return _this;
  }

  (0, _createClass2["default"])(UserBox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          userFullname = _this$props.userFullname,
          userEmail = _this$props.userEmail,
          userColor = _this$props.userColor,
          size = _this$props.size;
      var name = userFullname || userEmail;
      var luminance = -0.4;
      var randomColor = this.colorLuminance(userColor, luminance);
      var userBoxStyle = this.props.customStyle ? Object.assign(this.props.customStyle || {}, {
        backgroundColor: randomColor
      }) : {
        backgroundColor: randomColor
      };
      return /*#__PURE__*/_react["default"].createElement(Userbox, {
        style: userBoxStyle
      }, /*#__PURE__*/_react["default"].createElement(_userAvatar["default"], {
        userFullname: name,
        size: size,
        color: userColor
      }), /*#__PURE__*/_react["default"].createElement(InfoWrapper, null, /*#__PURE__*/_react["default"].createElement(Name, null, userFullname), /*#__PURE__*/_react["default"].createElement(Email, null, userEmail)));
    }
  }]);
  return UserBox;
}(_react.Component);

UserBox.propTypes = {
  userFullname: _propTypes["default"].string,
  userEmail: _propTypes["default"].string,
  userColor: _propTypes["default"].string,
  size: _propTypes["default"].number,
  customStyle: _propTypes["default"].any
};
UserBox.defaultProps = {
  size: 40,
  backgroundColor: '#0588d1'
};
var _default = UserBox;
exports["default"] = _default;